import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const LandmarkIcon = ({ className = '', width = 21,  height = 18 , color = 'currentColor' }) => {
    return (
        <svg
            className={className ? className : ''}
            fill='none'
            height={height}
            viewBox='0 0 21 18'
            width={width}
            xmlns='http://www.w3.org/2000/svg'>
            <path
                clipRule='evenodd'
                d='M10.0492 17.85V8.50039H11.0492V17.85H10.0492Z'
                fill={color}
                fillRule='evenodd'/>
            <path
                d='M5.67505 4.78086C5.67505 5.29722 5.25645 5.71582 4.74009 5.71582C4.22373 5.71582 3.80513 5.29722 3.80513 4.78086C3.80513 4.2645 4.22373 3.8459 4.74009 3.8459C5.25645 3.8459 5.67505 4.2645 5.67505 4.78086Z'
                fill={color}/>
            <path
                d='M16.8938 4.78086C16.8938 5.29722 16.4752 5.71582 15.9589 5.71582C15.4425 5.71582 15.0239 5.29722 15.0239 4.78086C15.0239 4.2645 15.4425 3.8459 15.9589 3.8459C16.4752 3.8459 16.8938 4.2645 16.8938 4.78086Z'
                fill={color}/>
            <path
                d='M4.58887 1.0002H4.7011L4.73983 1L4.77855 1.0002L7.65241 1.0002C6.85945 0.38172 5.86467 0.00993732 4.78342 0.000196288L4.69623 0.000196295C4.66035 0.000519594 4.62456 0.00124168 4.58887 0.00235833V1.0002Z'
                fill={color}/>
            <path
                d='M15.9389 1.0002V0.000195313L15.9161 0.000195314C14.8348 0.00991252 13.84 0.381699 13.047 1.0002L15.9209 1.0002H15.9389Z'
                fill={color}/>
            <path
                d='M15.1992 8.50019H14.1992V9.142C14.517 9.26919 14.8518 9.36297 15.1992 9.41899V8.50019Z'
                fill={color}/>
            <path
                clipRule='evenodd'
                d='M5.69922 9.3825C5.38938 9.44619 5.06851 9.47965 4.73983 9.47965C2.12209 9.47965 0 7.35756 0 4.73983C0 2.1726 2.04099 0.0820738 4.58887 0.00235833V1.0002H4.7011C2.65349 1.02097 1 2.6873 1 4.73983C1 6.80527 2.67438 8.47965 4.73983 8.47965C6.80527 8.47965 8.47965 6.80527 8.47965 4.73983C8.47965 2.6873 6.82616 1.02097 4.77855 1.0002L7.65241 1.0002C8.76451 1.86758 9.47965 3.22019 9.47965 4.73983C9.47965 6.6588 8.33926 8.31142 6.69922 9.05697V8.50019H5.69922V9.3825ZM5.69922 9.3825L5.69922 17.8498H6.69922L6.69922 9.05697C6.38294 9.20075 6.04807 9.31079 5.69922 9.3825ZM13.047 1.0002L7.65241 1.0002C6.85945 0.38172 5.86467 0.00993732 4.78342 0.000196288L15.9161 0.000195314C14.8348 0.00991252 13.84 0.381699 13.047 1.0002ZM14.1992 9.142C12.4531 8.44314 11.2197 6.73552 11.2197 4.73983C11.2197 3.22019 11.9349 1.86758 13.047 1.0002L15.9209 1.0002C13.8733 1.02091 12.2197 2.68726 12.2197 4.73983C12.2197 6.80527 13.8941 8.47965 15.9596 8.47965C18.025 8.47965 19.6994 6.80527 19.6994 4.73983C19.6994 2.67438 18.025 1 15.9596 1L15.9389 1.0002V0.000195313L15.9161 0.000195314L15.9596 0C18.5773 0 20.6994 2.12209 20.6994 4.73983C20.6994 7.35756 18.5773 9.47965 15.9596 9.47965C15.7007 9.47965 15.4468 9.45891 15.1992 9.41899V8.50019H14.1992V9.142ZM14.1992 9.142V17.8498H15.1992V9.41899C14.8518 9.36297 14.517 9.26919 14.1992 9.142ZM4.69623 0.000196295C4.66035 0.000519594 4.62456 0.00124168 4.58887 0.00235833V0.000196305L4.69623 0.000196295ZM4.69623 0.000196295L4.78342 0.000196288L4.73983 0L4.69623 0.000196295ZM4.77855 1.0002H4.7011L4.73983 1L4.77855 1.0002Z'
                fill={color}
                fillRule='evenodd'/>
            <path
                d='M6.69922 8.50019H5.69922V9.3825C6.04807 9.31079 6.38294 9.20075 6.69922 9.05697V8.50019Z'
                fill={color}/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default LandmarkIcon;
